export default [
  {
    url: "/",
    name: "Panel",
    slug: "reportSystem",
    icon: "HomeIcon",
  },
  {
    header: "Satışlar",
    url: "/Sales",
  },
  {
    url: "/Sales",
    name: "Nitro Satış",
    slug: "Sales",
    icon: "ShoppingBagIcon",
    submenu: [
      {
        url: "/Sales",
        name: "Satış İşlemleri",
        slug: "Sales",
      },
      {
        url: "/SubscriptionSystem",
        name: "Abonelikler",
        slug: "subscriptions",
        icon: "RefreshCcwIcon",
      },
    ],
  },
  {
    header: "B2B",
    url: "/B2B",
  },
  {
    url: "/B2B",
    name: "B2B",
    slug: "B2B",
    icon: "RefreshCwIcon",
    submenu: [
      {
        url: "/B2BDiscount",
        name: "İndirim İşlemleri",
        slug: "B2B",
      },
      {
        url: "/B2BSale",
        name: "B2B Satışlar",
        slug: "B2B",
      },
      {
        url: "/B2BCustomer",
        name: "B2B Müşteriler",
        slug: "B2B",
      },
     
    ],
  },

  {
    header: "Satın Alma",
    url: "/Purchase",
  },

  {
    url: "/Purchase",
    name: "Satın Alma",
    slug: "purchase",
    icon: "ShoppingCartIcon",
    submenu: [
      {
        url: "/Purchase",
        name: "Ürünler ve Stok Listesi",
        slug: "purchase",
      },
      {
        url: "/PurchaseList",
        name: "Talep Listesi",
        slug: "PurchaseList",
      },
      {
        url: "/CostTracking",
        name: "Maliyet İzleme",
        slug: "CostTracking",
      },
    ],
  },

  {
    header: "MUHASEBE MODÜLÜ",
    url: "/AccountMovement",
  },

  {
    url: "/AccountMovement",
    name: "Muhasebe",
    slug: "muhasebe",
    icon: "CrosshairIcon",
    submenu: [
      {
        url: "/AccountMovement",
        name: "Bekleyen Muhasebe Hareketleri",
        slug: "AccountMovement",
      },
      {
        url: "/TransactedMovementWatch",
        name: "Fiş Bazlı Hareket İzleme",
        slug: "TransactedMovementWatch",
      },

      {
        url: "/AccountMovementWatch",
        name: "Finansal Akış İzleme",
        slug: "AccountMovementWatch",
      },
      {
        url: "/MoneyTransfer",
        name: "Para Transferi",
        slug: "MoneyTransfer",
      },
      {
        url: "/AccountDashboard",
        name: "Nitro Mali Tablo",
        slug: "AccounDashboard",
      },

      {
        url: "/StatisticalDataDashboard",
        name: "Nitro İstatisiki Bilgiler",
        slug: "StatisticalDataDashboard",
      },
    ],
  },

  // {
  //   header: "ÜRETİM MODÜLÜ",
  // },

  {
    header: "CRM",
    url: "/Crm",
  },

  {
    url: "/Crm",
    name: "CRM",
    slug: "crm",
    icon: "UsersIcon",
    submenu: [
      {
        url: "/Crm",
        name: "Verimor Kayıt İzleme",
        slug: "VerimorCallTracking",
      },
      {
        url: "/CustomerComment",
        name: "Müşteri Yorum Takibi",
        slug: "customerComment",
      },
    ],
  },

  {
    header: "Gelir Gider",
    url: "/Expense",
  },

  {
    url: "/Expense",
    name: "Gelir Gider İşlemleri",
    slug: "Sales",
    icon: "CodesandboxIcon",
  },
  {
    url: "/Contacts",
    name: "Müşteriler",
    slug: "contacts",
    icon: "UserCheckIcon",
  },

  {
    header: "Depo",
    url: "/StockActions",
  },
  {
    url: "/StockActions",
    name: "Stok",
    slug: "stok",
    icon: "PackageIcon",
    submenu: [
      {
        url: "/StockActions",
        name: "Stok Aksiyonları",
        slug: "stokEdit",
      },
      // {
      //   url: "/ProductTransact",
      //   name: "Ürün İşlemleri",
      //   slug: "productEdit",
      // },
      // {
      //   url: "/productPrice",
      //   name: "Ürün Fiyat",
      //   slug: "productPrice",
      // },
      // {
      //   url: "/StockCounting",
      //   name: "Stok Sayım",
      //   slug: "stokEdit",
      // },
      {
        url: "/TransferTransact",
        name: "Transfer İşlemleri",
        slug: "categoryEdit",
      },
      {
        url: "/ProductControl",
        name: "Ürün Kontrol",
        slug: "productControl",
      },
    ],
  },

  {
    url: "/ReturnRequests",
    name: "İade istekleri",
    slug: "return-requests",
    icon: "TruckIcon",
  },
  {
    url: "/Products",
    name: "Ürünler",
    slug: "products",
    icon: "ArchiveIcon",
  },

  {
    header: "Teknik Servis & Garaj",
    url: "/TechnicService",
  },

  {
    url: "/SupportTicket",
    name: "SupportTicket",
    slug: "SupportTicket",
    icon: "HelpCircleIcon",
  },

  {
    url: "/TechnicService",
    name: "Teknik Servis",
    slug: "techService",
    icon: "CpuIcon",
  },

  {
    url: "/Garage",
    name: "Garaj",
    slug: "garage",
    icon: "ApertureIcon",
  },

  {
    header: "Yönetim",
    url: "/UserList",
  },

  {
    url: "/UserList",
    name: "İnsan Kaynakları",
    slug: "humanRes",
    icon: "UsersIcon",
    submenu: [
      {
        url: "/UserList",
        name: "Personel Listesi",
        slug: "userList",
      },
      {
        url: "/AdvanceResource",
        name: "Avans Kayıt Formu",
        slug: "advance",
      },
      {
        url: "/Permission",
        name: "İzin Kayıt Formu",
        slug: "permission",
      },

      {
        url: "/Management",
        name: "Personel Talep Yönetimi",
        slug: "permission",
      },

      {
        url: "/OrganizationalChart",
        name: "Nitro Organizasyon Şeması",
        slug: "organizationalchart",
      },

      {
        url: "/HRShift",
        name: "Mesai Bilgileri",
        slug: "HRShift",
        icon: "UsersIcon",
      },
      {
        url: "/PermissionList",
        name: "Personel İzin Yönetimi",
        slug: "permissionList",
      },
    ],
  },

  {
    url: "/HRProject",
    name: "Proje Yönetimi",
    slug: "ProjectManagement",
    icon: "SlackIcon",
    submenu: [
      {
        url: "/HRProject",
        name: "Projeler",
        slug: "HRProjectList",
      },
      {
        url: "/HRTimesheet",
        name: "Haftalık Plan",
        slug: "HRTimesheet",
      },
    ],
  },

  {
    header: "PARAMETRİK EKRANLAR",
    url: "/WarehouseUser",
  },

  {
    url: "/WarehouseUser",
    name: "Parametrik Ekranlar",
    slug: "parametricscreens",
    icon: "TabletIcon",
    submenu: [
      {
        url: "/Authorisation",
        name: "Yetkiler",
        slug: "parametricscreens",
      },
      {
        url: "/UserAuthorisation",
        name: "Personel Yetkileri",
        slug: "parametricscreens",
      },
      {
        url: "/Warehouses",
        name: "Depolar",
        slug: "warehouses",
      },
      {
        url: "/WarehouseUser",
        name: "Personel Deposu",
        slug: "warehouseUser",
      },
      {
        url: "/Department",
        name: "Departmanlar",
        slug: "department",
      },
      {
        url: "/Title",
        name: "Ünvanlar",
        slug: "title",
      },
      {
        url: "/Team",
        name: "Takımlar",
        slug: "team",
      },
      {
        url: "/Tags",
        name: "Etiketler",
        slug: "tags",
      },
      {
        url: "/ProductBrand",
        name: "Markalar",
        slug: "productBrand",
      },
      {
        url: "/ProductCategory",
        name: "Kategoriler",
        slug: "productCategory",
      },
      // {
      //   url: "/AccountCompanyType",
      //   name: "Harcama Türleri",
      //   slug: "accountCompanyType",
      // },
      {
        url: "/AccountMovementUpdate",
        name: "Hesap Hareket İşlemleri",
        slug: "accountMovementUpdate",
      },
      {
        url: "/ProductManifactureType",
        name: "Üretim Tür İşlemleri",
        slug: "productManifactureType",
      },
      {
        url: "/InventoryStockType",
        name: "Envanter Tür İşlemleri",
        slug: "inventoryStockType",
      },
      {
        url: "/DynamicMenu",
        name: "Dinamik Menü",
        slug: "dynamicMenu",
      },
      {
        url: "/Router",
        name: "Routerlar",
        slug: "router",
      },
      // {
      //   url: "/routerUser",
      //   name: "Personel Routerları",
      //   slug: "routerUser",
      // },
      {
        url: "/RouterDefaultUserType",
        name: "Kullanıcı Türüne Göre Routerlar",
        slug: "RouterDefaultUserType",
      },
      {
        url: "/DailyCurrencies",
        name: "Günlük Kurlar",
        slug: "dailyCurrencies",
      },
      {
        url: "/SaleUpdate",
        name: "Satış Güncelleme",
        slug: "SaleUpdate",
      },
    ],
  },

  {
    header: "ARGE",
    url: "/ObdTalkParam",
  },

  {
    url: "/ObdTalkParam",
    name: "Obd2Talk",
    slug: "arge",
    icon: "ActivityIcon",
    submenu: [
      {
        url: "/ObdTalkParam",
        name: "Obd2Talk Veri İşlem",
        slug: "arge",
      },
      {
        url: "/ObdTalkParamV2",
        name: "Obd2Talk Veri İşlem(V2)",
        slug: "arge",
      },

      {
        url: "/CarCanbusData",
        name: "Car Canbus Data Oku",
        slug: "arge",
      },

      {
        url: "/FirmwareUpdate",
        name: "Firmware Güncelleme",
        slug: "arge",
      },
    ],
  },

  {
    header: "OTOMATİK İŞLEMLER",
    url: "/AutomaticOperation",
  },

  {
    url: "/AutomaticOperation",
    name: "Otomatik İşlemler",
    slug: "arge",
    icon: "Maximize2Icon",
    submenu: [
      {
        url: "/AutomaticOperation",
        name: "Otomatik İşlemler Çalıştırma",
        slug: "AutomaticOperation",
      },
    ],
  },

  {
    header: "ÜRETİM MODÜLÜ",
    url: "/ProductionWizard",
  },

  {
    url: "/ProductionWizard",
    name: "Üretim",
    slug: "production",
    icon: "BarChart2Icon",
    submenu: [
      {
        url: "/ProductionWizard",
        name: "Üretim Oluşturma",
        slug: "ProductionWizard",
      },
      {
        url: "/ProductionList",
        name: "Üretim Listesi",
        slug: "ProductionList",
      },
      {
        url: "/ProductionReceipt",
        name: "Üretim Reçetesi",
        slug: "ProductionReceipt",
      },
    ],
  },

  {
    header: "RAPORLAMA MODÜLÜ",
    url: "/Reports",
  },

  {
    url: "/Reports",
    name: "Raporlar",
    slug: "reports",
    icon: "ClipboardIcon",
    submenu: [
      {
        url: "/Reports",
        name: "Personel Raporları",
        slug: "reports",
      },
      {
        url: "/CustomerReports",
        name: "Müşteri Raporları",
        slug: "reports",
      },
      {
        url: "/SummaryReports",
        name: "Özet Raporlar",
        slug: "reports",
      },
      {
        url: "/TechnicReports",
        name: "Teknik & Garaj Raporu",
        slug: "reports",
      },
      {
        url: "/SupportTicketReport",
        name: "Support Ticket Raporu",
        slug: "SupportTicketReport",
      },
    ],
  },

  {
    header: "ZİMMET MODÜLÜ",
    url: "/InventoryStock",
  },

  {
    url: "/InventoryStock",
    name: "ZİMMET",
    slug: "InventoryStock",
    icon: "ScissorsIcon",
    submenu: [
      {
        url: "/InventoryStock",
        name: "Zimmet İşlemleri",
        slug: "InventoryStock",
      },
      {
        url: "/InventoryStockList",
        name: "Zimmet Listesi",
        slug: "InventoryStockList",
      },
    ],
  },

  {
    url: "/Settings",
    name: "Ayarlar",
    slug: "settings",
    icon: "SettingsIcon",
    submenu: [
      {
        url: "/Settings",
        name: "Ayarlar",
        slug: "settings",
        icon: "SettingsIcon",
      },
    ],
  },
];
